import { Component, Element, Event, EventEmitter, h, Host, Method, Prop } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'anchor-read-more',
  styleUrl: 'read-more.scss',
  shadow: true,
})
export class ReadMore {
  @Element() hostElement: HTMLStencilElement;

  /**
   *  Give this instance of read-more a custom ID, or keep the default.
   */
  @Prop({}) uuid: string = uuidv4();

  /**
   * Whether the read-more starts expanded
   */
  @Prop({ mutable: true, reflect: true }) expanded: boolean = false;

  /**
   * Set a visually emphasized state
   */
  @Prop({ mutable: true, reflect: true }) emphasized: boolean = false;

  /**
   * Event dispatched when read-more expands or contracts
   */
  @Event() toggled: EventEmitter<{ value: boolean }>;

  hasShowLessSlot: boolean;

  @Method()
  async toggleExpand() {
    this.expanded = !this.expanded;
    this.toggled.emit({ value: this.expanded });
  }

  componentWillLoad() {
    this.hasShowLessSlot = !!this.hostElement.querySelector('[slot="show-less"]');
  }

  render() {
    return (
      <Host>
        <div id={this.uuid} class={{ 'anchor-c-read-more': true, 'anchor-c-read-more--emphasized': this.emphasized, 'expanded': this.expanded }}>
          <button class={{ 'anchor-c-read-more__link': true }} onClick={() => this.toggleExpand()}>
            {this.expanded && this.hasShowLessSlot ? <slot name="show-less" /> : <slot name="show-more" />}
            <anchor-icon class="anchor-c-read-more__icon" name="chevron-down" size="small" stroke={1.5}></anchor-icon>
          </button>
          <div class="anchor-c-read-more__text">
            <slot name="long-text" />
          </div>
        </div>
      </Host>
    );
  }
}
